export default __webpack_public_path__ + "static/2-9ed7404c25b0e315dfdd71b527271fce.jpeg";